import { type IInputTask, InputTaskCategory } from 'interfaces/IInputTask';

import type { ProductionMatrixKey } from './stepFactory';

const RANGE_KEYS = new Set<ProductionMatrixKey>([
  'yieldLow',
  'yieldHigh',
  'priceLow',
  'priceHigh',
]);

/**
 * Low and High are planning scenarios: an Actual production task records
 * what happened, so it has only the one (Expected) yield and price.
 */
export const hasProductionRange = (task: Pick<IInputTask, 'category'>) =>
  task.category !== InputTaskCategory.Actual;

/** True for the Low and High yield and price fields. */
export const isProductionRangeKey = (key: ProductionMatrixKey) =>
  RANGE_KEYS.has(key);
